/**
 * Zoektermen van de site, zoals ze naar de statistiek gaan. Nooit iets dat naar een persoon
 * wijst: geen e-mailadres, geen telefoon- of ordernummer, geen postcode. Puur, met tests.
 */

export const SEARCH_TERM_MAX = 50
export const SEARCH_TERM_MIN = 2

const EMAIL = /[^\s@]+@[^\s@]+/
/** Meer dan 4 cijfers achter elkaar (telefoon, ordernummer, iban). */
const LONG_DIGITS = /\d{5,}/
/** Nederlandse postcode: "1234 ab" of "1234ab". */
const POSTCODE = /\b\d{4}\s?[a-z]{2}\b/i
/** Onze eigen ordernummers ("bb-…", "s2026-…"). */
const ORDER_NUMBER = /\b(bb|s\d{4})-[a-z0-9]+/i

/** Wijst deze tekst mogelijk naar een persoon of bestelling? Dan gaat hij nergens heen. */
export function looksPersonal(value: string): boolean {
  return EMAIL.test(value) || LONG_DIGITS.test(value.replace(/[\s.-]/g, '')) || POSTCODE.test(value) || ORDER_NUMBER.test(value)
}

/** Kleine letters, enkele spaties, hoogstens 50 tekens; `null` als hij niet mee mag. */
export function normalizeSearchTerm(raw: string): string | null {
  const term = raw.normalize('NFC').toLowerCase().replace(/\s+/g, ' ').trim().slice(0, SEARCH_TERM_MAX).trim()
  if (term.length < SEARCH_TERM_MIN) return null
  return looksPersonal(term) ? null : term
}
